<template>
<v-container class="pa-0" >
    <iframe type="application/pdf" v-if="pdf" :src="pdf" frameborder="0" width="100%" height="900px"></iframe>
    <v-card  style="border-radius: 0;" v-else>
      <v-card-text class="text-xs-center">
        <v-progress-circular :width="6" :size="60" indeterminate color="primary"></v-progress-circular>
      </v-card-text>
    </v-card>
    <div style="width:100%; height:0px; overflow: hidden">
    <orders @png="savePng" />
    <costs  @png="savePng"/>
    <resume @png="savePng"/>
    <stockDelay @png="savePng"/>
    <graph @png="savePng"/>
    <buffers @png="savePng"/>
    </div>

</v-container>
</template>

<script>
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import orders from './Orders'
import costs from './Cost'
import resume from './Resume'
import stockDelay from './StockDelay'
import graph from './Graph'
import buffers from './Buffers'
import Config from "@/config";
export default {
  components: {
    orders,
    costs,
    resume,
    stockDelay,
    graph,
    buffers
  },
  data() {
    return {
      orders: null,
      costs: null,
      graph: null,
      stockdelay: [],
      buffers: [],
      pdf: ""
      };
  },
  methods: {
    savePng (imgData) {
      this[imgData.chart] = imgData.png
      if (this.orders && this.costs && this.stockdelay.length && this.graph && (this.buffers.length || !this.$store.state.games.current.gameVersion.dd)) {
        this.renderPDF()
      }
    },
    async renderPDF() {
      let pdf = new jsPDF('landscape');
      pdf.setFontSize(30)

      var logoFsg = new Image()
      logoFsg.src = '/images/logo_flow_simulation_game_by_AGILEA.png'

      let logoCompany = null
      if (this.$store.state.games.current.gameVersion.style.logo !== 'defaults/default-logo.png') {
        logoCompany = await this.getImage(this.config.filesUrl + this.$store.state.games.current.instance + "/logo/" + this.$store.state.games.current.gameVersion.style.logo)
      } else {
        logoCompany = await this.getImage(this.config.filesUrl + this.$store.state.games.current.instance + "/logo/" + this.$store.state.user.current.instance.logo)
      }

      let dividedBy = (logoCompany.naturalHeight / 15).toFixed(0)
      let logoWidth = logoCompany.naturalWidth / dividedBy
      let logoHeight = logoCompany.naturalHeight / dividedBy
      let logoX = 297 - logoWidth - 5
      let logoY = 210 - logoHeight - 5

      pdf.text(this.$store.state.games.current.name, 297/2, 150,{align: 'center'})
      pdf.addImage(logoFsg, 'PNG', 40, 50, 220, 75, 'logoFSG', 'FAST');

      pdf.addPage()
      pdf.text(this.$t('inGame.supplychainGraph'), 297/2, 25,{align: 'center'})
      pdf.addImage(this.graph, 'PNG', 0, 40, 297, 115, 'graph', 'FAST');
      pdf.addImage(logoFsg, 'PNG', 5, 190, 55, 18, 'logoFSG', 'FAST');
      pdf.addImage(logoCompany, 'PNG', logoX, logoY, logoWidth, logoHeight, 'logoCompany', 'FAST');

      pdf.addPage()
      pdf.text(this.$t('inGame.resume.resume'), 297/2, 25,{align: 'center'})
      pdf.autoTable({ html: document.getElementsByClassName('v-table')[0], startY: 50, styles: {halign: 'center'} })
      pdf.addImage(logoFsg, 'PNG', 5, 190, 55, 18, 'logoFSG', 'FAST');
      pdf.addImage(logoCompany, 'PNG', logoX, logoY, logoWidth, logoHeight, 'logoCompany', 'FAST');

      pdf.addPage()
      pdf.text(this.$t('inGame.orders'), 297/2, 25,{align: 'center'})
      pdf.addImage(this.orders.imgURI, 'PNG', 25, 50, 240, 120, 'orders', 'FAST');
      pdf.addImage(logoFsg, 'PNG', 5, 190, 55, 18, 'logoFSG', 'FAST');
      pdf.addImage(logoCompany, 'PNG', logoX, logoY, logoWidth, logoHeight, 'logoCompany', 'FAST');


      pdf.addPage()
      pdf.text(this.$t('inGame.costs'), 297/2, 25,{align: 'center'})
      pdf.addImage(this.costs.imgURI, 'PNG', 10, 50, 270, 100, 'cost', 'FAST');
      pdf.addImage(logoFsg, 'PNG', 5, 190, 55, 18, 'logoFSG', 'FAST');
      pdf.addImage(logoCompany, 'PNG', logoX, logoY, logoWidth, logoHeight, 'logoCompany', 'FAST');

     

      let x = 0
      for (const chart of this.stockdelay) {
        if (x === 0) {
          pdf.addPage()
          pdf.text(this.$t('inGame.stockRemains'), 297/2, 25,{align: 'center'})
          pdf.addImage(logoFsg, 'PNG', 5, 190, 55, 18, 'logoFSG', 'FAST');
          pdf.addImage(logoCompany, 'PNG', logoX, logoY, logoWidth, logoHeight, 'logoCompany', 'FAST');
          pdf.addImage(chart.imgURI, 'PNG', 10, 40, 135, 60, '', 'FAST');
        } else if(x === 1) {
          pdf.addImage(chart.imgURI, 'PNG', 150, 40, 135, 60, '', 'FAST');
        } else if(x === 2) {
          pdf.addImage(chart.imgURI, 'PNG', 10, 110, 135, 60, '', 'FAST');
        } else if(x === 3) {
          pdf.addImage(chart.imgURI, 'PNG', 150, 110, 135, 60, '', 'FAST');
          
          x = -1
        }
        x++
      }

      if (this.$store.state.games.current.gameVersion.dd) {
        for (const chart of this.buffers) {
          if (x === 0) {
            pdf.addPage()
            pdf.text(this.$t('inGame.buffers'), 297/2, 25,{align: 'center'})
            pdf.addImage(logoFsg, 'PNG', 5, 190, 55, 18, 'logoFSG', 'FAST');
            pdf.addImage(logoCompany, 'PNG', logoX, logoY, logoWidth, logoHeight, 'logoCompany', 'FAST');
            pdf.addImage(chart, 'PNG', 18, 40, 260, 60, '', 'FAST');
          } else if(x === 1) {
            pdf.addImage(chart, 'PNG', 18, 110, 260, 60), '', 'FAST';
            x = -1
          }
          x++
        }
      }
      
      let data = pdf.output("bloburl")
      this.pdf = data
      //pdf.save("download.pdf");
    },
    getImage(url){
      return new Promise(function(resolve, reject){
          var img = new Image()
          img.onload = function(){
              resolve(img)
          }
          img.onerror = function(){
              reject(url)
          }
          img.src = url
      })
    }
  },
  computed: {
    config() {
      return Config;
    }
  }
}
</script>

<style>

</style>